import React, { Component } from 'react';
import '../style.css';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_indiaHigh from "@amcharts/amcharts4-geodata/indiaHigh";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { COUTRIES_WITH_CASES } from '../constants';
import { setCountryColour, setCountryData, getLegendSlicedData, setStateData } from '../helper';
import { Row, Col, Card, CardBody } from 'reactstrap';
import * as constant from '../../../Corporate/dashboard/constant';
import { Preloading } from '../../../components/UI/Preloader/action';
import { connect } from 'react-redux';
am4core.useTheme(am4themes_animated);
class IndiaMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMore: false,
            countryList: [],
            itemsToShow: 3,
            expanded: false,
            mapData: null,
        }
        this.regionalSeries = {};
        this.currentSeries = null;
        this.chart = null;
        this.polygonSeries = null;
        this.zoomOut = null;
        this.legend = null;
        this.legendbutton = null;
    }
    componentDidUpdate(prevProps){
        if (Object.entries(this.props.data).length !== Object.entries(prevProps.data).length) {
            this.setState({mapData:this.props.data});
            this.createChartWithData();
    }else if(Object.entries(this.props.data).length === 0){
        this.createChartWithoutData();
    }
    }

    componentDidMount() {
        if (Object.entries(this.props.data).length) {
            this.setState({mapData:this.props.data})
                this.createChartWithData();
        }else{
            this.createChartWithoutData();
        }


    }
    createChartWithoutData = () => {
        this.chart = am4core.create("chartdiv", am4maps.MapChart);
        this.chart.maxZoomLevel = 40;

        // Set map definition
        this.chart.geodata = am4geodata_indiaHigh;
        this.chart.visible = true;

        // Set projection
        this.chart.projection = new am4maps.projections.Miller();
        let button = this.chart.chartContainer.createChild(am4core.Button);
        // button.label.text = "...";
        button.padding(0, 5, 10, 5);
        button.background.fill = "#fff"
        button.background.states.getKey("hover").properties.fill = am4core.color("#fff");
        button.background.states.getKey("down").properties.fill = am4core.color("#fff");
        button.width = 40;
        button.height = 30;
        button.align = "right";
        button.marginRight = 15;
        button.icon = new am4core.Sprite();
        button.icon.path = "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
        button.icon.height = 40
        button.events.on("hit", () => {
            this.chart.goHome();
        });

        // Create map polygon series
        this.polygonSeries = this.chart.series.push(new am4maps.MapPolygonSeries());
        this.polygonSeries.useGeodata = true;
        this.polygonSeries.calculateVisualCenter = true;
        this.polygonSeries.exclude = ["AQ"];
        this.legend = new am4maps.Legend();
        let legendContainer = am4core.create("legenddiv", am4core.Container);
        legendContainer.width = am4core.percent(100);
        legendContainer.height = am4core.percent(101);
        this.legend.parent = legendContainer;

        let polygonTemplate = this.polygonSeries.mapPolygons.template;
        polygonTemplate.stroke = am4core.color("#454a58");
        polygonTemplate.strokeWidth = 0.3;
        polygonTemplate.propertyFields.fill = "fill";
        /*polygonTemplate.tooltipText = `[bold]{name}[/]
        Cumulative Score: {score}
        Number Of Cases: {noOfcases}`;*/
        polygonTemplate.tooltipText = `[bold]{name}[/]
        Cumulative Score: {score}
        Business Relations: {businessRelations}`;
        polygonTemplate.fill = am4core.color("#fff");
        polygonTemplate.events.on("hit", (ev) => {
            // ev.target.series.chart.zoomToMapObject(ev.target);
            // this.props.filter('', '', '', constant.COMPLETE, ev.target.dataItem.dataContext.name)
        })
        let hs = polygonTemplate.states.create("hover");
        hs.properties.fill = am4core.color("#005073");
    }
    createChartWithData = () => {
        this.chart = am4core.create("chartdiv", am4maps.MapChart);
        this.chart.maxZoomLevel = 40;

        // Set map definition
        this.chart.geodata = am4geodata_indiaHigh;
        this.chart.visible = true;

        // Set projection
        this.chart.projection = new am4maps.projections.Miller();
        let button = this.chart.chartContainer.createChild(am4core.Button);
        // button.label.text = "...";
        button.padding(0, 5, 10, 5);
        button.background.fill = "#fff"
        button.background.states.getKey("hover").properties.fill = am4core.color("#fff");
        button.background.states.getKey("down").properties.fill = am4core.color("#fff");
        button.width = 40;
        button.height = 30;
        button.align = "right";
        button.marginRight = 15;
        button.icon = new am4core.Sprite();
        button.icon.path = "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
        button.icon.height = 40
        button.events.on("hit", () => {
            this.chart.goHome();
        });

        // Create map polygon series
        this.polygonSeries = this.chart.series.push(new am4maps.MapPolygonSeries());
        this.polygonSeries.useGeodata = true;
        this.polygonSeries.calculateVisualCenter = true;
        this.polygonSeries.exclude = ["AQ"];
        this.polygonSeries.data = setStateData(this.props.data, this.chart.geodata.features,this.props.corporateId);
        let hover = this.polygonSeries.mapPolygons.template.states.create("highlight");
        hover.properties.fill = am4core.color("#69975F");

        this.legend = new am4maps.Legend();
        let legendContainer = am4core.create("legenddiv", am4core.Container);
        legendContainer.width = am4core.percent(100);
        legendContainer.height = am4core.percent(101);
        this.legend.parent = legendContainer;
        this.legend.data = setStateData(this.props.data, this.chart.geodata.features, this.props.corporateId).splice(0, 5);
        this.legend.labels.template.text = "[bold {color}]{name}[/]";
        this.legend.background.fill = am4core.color("#000");
        this.legend.background.fillOpacity = 0.01;
        this.legend.width = '100px';
        this.legend.align = "left";
        this.legend.paddingLeft = 4;
        this.legend.labels.template.maxWidth = 90;
        this.legend.labels.template.truncate = false;
        this.legend.labels.template.wrap = true;
        this.legend.itemContainers.template.events.on('hit', (ev) => {
            this.props.filter('', '', '', constant.COMPLETE, ev.target.dataItem.dataContext.CNTRY,'', ev.target.dataItem.dataContext.name)
        })
        this.legend.events.on("datavalidated", this.resizeLegend);
        this.legend.events.on("maxsizechanged", this.resizeLegend);
        this.legend.itemContainers.template.events.on("over", this.over)
        this.legend.itemContainers.template.events.on("out", this.out)


        this.legendbutton = legendContainer.createChild(am4core.Button);
        this.legendbutton.label.text = "show more";
        this.legendbutton.align = "right";
        this.legendbutton.valign = "bottom";
        this.legendbutton.background.fill = "#fff";
        this.legendbutton.background.states.getKey("hover").properties.fill = am4core.color("#fff");
        this.legendbutton.background.states.getKey("down").properties.fill = am4core.color("#fff");
        this.legendbutton.marginRight = 15;
        this.legendbutton.events.on("hit", () => this.showMore())

        // Configure series

        let polygonTemplate = this.polygonSeries.mapPolygons.template;
        polygonTemplate.stroke = am4core.color("#454a58");
        polygonTemplate.strokeWidth = 0.3;
        polygonTemplate.propertyFields.fill = "fill";
        polygonTemplate.tooltipText = `[bold]{name}[/]
        Cumulative Score: {avgScore}
        Case Count: {caseCount}`;
        // Business Relations: {businessRelations}`;
        polygonTemplate.fill = am4core.color("#fff");
        polygonTemplate.events.on("hit", (ev) => {
        //     // ev.target.series.chart.zoomToMapObject(ev.target);
            this.props.filter('', '', '', constant.COMPLETE, ev.target.dataItem.dataContext.CNTRY,'', ev.target.dataItem.dataContext.name)
        })
        let hs = polygonTemplate.states.create("hover");
        hs.properties.fill = am4core.color("#005073");
    }
    resizeLegend = (ev) => {
        document.getElementById("legenddiv").style.height = this.legend.contentHeight + 30 + "px";
    }

    showLegendButton = () => {
        if (this.state.expanded === false) {
            this.legendbutton.label.text = 'show more'
        } else {
            this.legendbutton.label.text = 'show less'
        }
    }
    showLegendData = () => {
        if (this.state.expanded === false) {
            this.legend.data = setStateData(this.props.data, this.chart.geodata.features, this.props.corporateId).splice(0, 5);
        } else {
            this.legend.data = setStateData(this.props.data, this.chart.geodata.features, this.props.corporateId)
        }

    }
    showMore = () => {
        this.setState((prevState) => ({
            expanded: !prevState.expanded
        }), () => {
            this.showLegendData();
            this.showLegendButton()
        })
    }
    over = (ev) => {
        let shadow = this.polygonSeries.filters.push(new am4core.DropShadowFilter());
        shadow.opacity = 0.1;
        let hoverState = this.polygonSeries.getPolygonById(ev.target.dataItem.dataContext.id);
        hoverState.properties.fill = am4core.color(ev.target.dataItem.dataContext.fill);
        hoverState.properties.dx = -5;
        hoverState.properties.dy = -5;
        let hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter());
        hoverShadow.dx = 6;
        hoverShadow.dy = 6;
        hoverShadow.opacity = 0.3;
    }

    out = (ev) => {
        let shadow = this.polygonSeries.filters.push(new am4core.DropShadowFilter());
        shadow.opacity = 0.1;
        let hoverState = this.polygonSeries.getPolygonById(ev.target.dataItem.dataContext.id);
        hoverState.properties.fill = am4core.color(ev.target.dataItem.dataContext.fill);
        hoverState.properties.dx = 0;
        hoverState.properties.dy = 0;
        let hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter());
        hoverShadow.dx = 0;
        hoverShadow.dy = 0;
        hoverShadow.opacity = 0;
    }
    render() {
        return (
            <Card className="accord-body border-0">
                <CardBody className="p-0">

                    <Row noGutters>
                        <Col xs='18' className="d-flex align-items-center flex-column flex-sm-row" id="chartdiv" style={{ width: "100%", height: "69vh" }}></Col>
                        <Col xs='6' id="legendwrapper" className="d-flex flex-column flex-sm-row">
                            <div id="legenddiv"></div>
                        </Col>
                    </Row>

                </CardBody>
            </Card>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default connect(null, mapDispatchToProps)(IndiaMap);


